import type { Mission } from '../missions.ts'

export const ncua: Mission = {
  id: "ncua",
  name: "National Credit Union Administration",
  short: "NCUA",
  call: "Credit Unions",
  kind: "independent",
  community: "financial",
  url: "https://ncua.gov/",
  established: 1970,
  palette: {
    primary: "#17264a",
    secondary: "#005596",
    accent: "#f7cc6e",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:NCUA_official_seal.svg",
  },
  motif: "hands",
  mission: {
    text: "Enable access to financial services by facilitating safe, sound, and resilient credit unions.",
    url: "https://ncua.gov/about/mission-values",
  },
  fact: {
    text: "Backed by the full faith and credit of the United States, the National Credit Union Share Insurance Fund provides up to $250,000 of federal share insurance in all federal credit unions and most state-chartered credit unions.",
    url: "https://ncua.gov/about/mission-values",
  },
  seal: {
    file: "public/seals/ncua.svg",
    source: "https://commons.wikimedia.org/wiki/File:NCUA_official_seal.svg",
  },
  identifier: {
    about: "https://ncua.gov/about",
    accessibility: "https://ncua.gov/accessibility-statement",
    foia: "https://ncua.gov/foia",
    noFear: "https://ncua.gov/no-fear-act",
    oig: "https://ncua.gov/about/inspector-general",
    performance: "https://ncua.gov/about/budget-performance",
    privacy: "https://ncua.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/ncua-credit-union.jpg",
        small: "/media/ncua-credit-union-sm.jpg",
        alt: "An Art Deco federal credit union office with a drive-through canopy on a small-town street",
        title: "Great Plains Federal Credit Union office along old U.S. Route 66, Carthage, Missouri",
        creator: "Carol M. Highsmith",
        source: "https://www.loc.gov/item/2020742330/",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
